export default "__VITE_ASSET__BzaPBAxj__"